import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import de from './de.json';
import pt from './pt.json';
import it from './it.json';
import ja from './ja.json';
import zh from './zh.json';
import ko from './ko.json';
import ar from './ar.json';
import hi from './hi.json';
import ru from './ru.json';

export const localeBundles = {
    en,
    es,
    fr,
    de,
    pt,
    it,
    ja,
    zh,
    ko,
    ar,
    hi,
    ru,
} as const;

export type LocaleCode = keyof typeof localeBundles;
